import { useCallback, useRef } from 'react';
import { formatTimelineTime } from '@src/services/timeline';

/**
 * A time label written straight to the DOM, for something that moves with
 * playback without re-rendering.
 *
 * Returns the ref to attach and a `draw(sec)` to call each animation frame. The
 * string is only rebuilt when the whole second changes, and it is compared
 * against the DOM rather than a ref — a React re-render puts the prop's value
 * back, and this corrects it on the next frame.
 */
const useTimeLabel = () => {
  const ref = useRef(null);
  const wholeRef = useRef(null);
  const labelRef = useRef('');

  const draw = useCallback((sec) => {
    const whole = Math.floor(sec);
    if (whole !== wholeRef.current) {
      wholeRef.current = whole;
      labelRef.current = formatTimelineTime(sec);
    }
    const el = ref.current;
    if (el && el.textContent !== labelRef.current) {
      el.textContent = labelRef.current;
    }
  }, []);

  return [ref, draw];
};

export default useTimeLabel;
